import React from 'react';
import PropTypes from 'prop-types';
import WithClickTracking from '../../components/WithClickTracking';
import CallToActionImageBlock from '../../../blocks/CallToActionImageBlock';
import CallToActionExploreBlock from '../../../blocks/CallToActionExploreBlock';

import ProductTileWithVariations from '../Products/ProductTileWithVariations';
import { solutionListName } from '../../Infrastructure/gtm';

const ProductTileWithVariationsWithClickTracking = WithClickTracking(ProductTileWithVariations);

const SolutionTileContainer = ({ results, onResultClick, additionalBlocks, addToCartEndPoint, wishlistData, toggleAddToListModal, setNewVariantQuantity, loginPageUrl, isUserLoggedIn, isOrderRequestOnlyMarket }) => {
    return(
        <div className="product-list__body solutions__body">
            <div className="row">
                {results.map((product, i) => {
                    var showCallToAction = (results.length < 7 && i === 3 || i === 6) && !!additionalBlocks;
                    return (
                        <React.Fragment key={i}>
                            {showCallToAction && additionalBlocks.callToActionImage &&
                                <div className="col-12 mb-4">
                                    <CallToActionImageBlock {...additionalBlocks.callToActionImage} />
                                </div>
                            }
                            {showCallToAction && additionalBlocks.callToActionExplore &&
                                <div className="col-12 mb-4">
                                    <CallToActionExploreBlock {...additionalBlocks.callToActionExplore} />
                                </div>
                            }
                            <div className="col-12 mb-4">
                                <ProductTileWithVariationsWithClickTracking   
                                    {...product}
                                    onResultClick={onResultClick}
                                    addToCartEndPoint={addToCartEndPoint}
                                    listName={solutionListName}
                                    wishlistData={wishlistData}
                                    toggleAddToListModal={toggleAddToListModal}
                                    setNewVariantQuantity={setNewVariantQuantity}
                                    loginPageUrl={loginPageUrl}
                                    isUserLoggedIn={isUserLoggedIn}
                                    isOrderRequestOnlyMarket={isOrderRequestOnlyMarket}
                                />
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};


SolutionTileContainer.propTypes = {
    results: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        Link: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        DefaultVariationCode: PropTypes.string
    })),
    addToCartEndPoint: PropTypes.string
};

export default SolutionTileContainer;